import anime from 'animejs';

class Form {

  constructor(formElement) {
    this.form = formElement;

    this.form.addEventListener('submit', () => {
      event.preventDefault();
      this._submit();
    });

    this.inputs = this.form.getElementsByClassName('form__input-row');

    let selects = this.form.querySelectorAll('.form__select--unselected');

    for ( let i = 0; i < selects.length; i++ ) {
      let select = selects[i];
      select.addEventListener('change', function() {
        this.classList.remove('form__select--unselected');
      });
    }

    for ( let i = 0; i < this.inputs.length; i++ ) {
      let inputRow = this.inputs[i];
      let input;

      if ( inputRow.classList.contains('form__input-row--select') ) {
        input = inputRow.querySelector('select');
      } else if ( inputRow.classList.contains('form__input-row--textarea') ) {
        input = inputRow.querySelector('textarea');
      } else if ( inputRow.classList.contains('form__input-row--recaptcha') ) {
        input = inputRow.querySelector('.g-recaptcha');
      } else {
        input = inputRow.querySelector('input');
      }

      input.addEventListener('input', function() {
        if ( this.value ) {
          inputRow.classList.add('form__input-row--has-data');
        } else {
          inputRow.classList.remove('form__input-row--has-data');
        }
      });
    }
  }

  _toggleButtonLoading( state ) {
    const formSubmitButton = this.form.querySelector('.form__submit-button');

    if ( state == 'loading' ) {
      formSubmitButton.disabled = true;
      formSubmitButton.classList.add('button--loading');
      formSubmitButton.dataset.submitText = formSubmitButton.innerHTML;
      formSubmitButton.innerHTML = 'Please wait...';
    } else {
      formSubmitButton.disabled = false;
      formSubmitButton.classList.remove('button--loading');
      formSubmitButton.innerHTML = formSubmitButton.dataset.submitText;
    }
  }

  _submit() {
    const request = new XMLHttpRequest();
    const formData = new FormData(this.form);
    const formId = this.form.dataset.id;

    this._toggleButtonLoading('loading');

    formData.append('form_id', formId);

    /* eslint-disable */
    let token = scriptVars.token;
    let ajaxUrl = scriptVars.ajaxUrl;
    /* eslint-enable */

    formData.append('token', token);

    const _self = this;

    let errorResponse = {
      has_errors: true,
      title: 'Sorry',
      message: 'Something went wrong. Please try again or contact us for assistance.',
    }

    request.onreadystatechange = function() {
      if ( this.readyState == 4 && this.status == 200 ) {

        // Uncomment to debug in console
        // console.log(this.responseText);

        let response = JSON.parse(this.responseText);

        if ( !response ) {
            response = errorResponse;
        }

        _self._showResults(response);

        } else if ( this.readyState == 4 && this.status != 200 ) {
          let response = errorResponse;
          _self._showResults(response);
        }
    }

    request.open( 'POST', ajaxUrl + '?action=submit_form' )
    request.send( formData )

  }

  _showResults(response) {
    this.form.classList.remove('form--has-errors');

    this._toggleButtonLoading('loaded');

    for ( let i = 0; i < this.inputs.length; i++ ) {
      let inputRow = this.inputs[i];

      inputRow.classList.remove('form__input-row--has-errors');
    }

    let errorMessages = this.form.querySelectorAll('.form__error-message');

    for ( let i = 0; i < errorMessages.length; i++ ) {
      errorMessages[i].remove();
    }

    if ( response.has_errors ) {
      // show validation messages
      this.form.classList.add('form--has-errors');

      for ( let i = 0; i < response.errors.length; i++ ) {
        let error = response.errors[i];
        let targetInput = this.form.querySelector('[name="' + error.name + '"]');
        let targetInputRow = targetInput.closest('.form__input-row');
        targetInputRow.classList.add('form__input-row--has-errors');

        let errorMessage = document.createElement('div');

        errorMessage.classList.add(
          'form__error-message',
          'font-size-small',
          'font-weight-bold',
          'fg-color-validation',
          'mt-2px',
          'pos-abs',
          'bottom--30px'
        );

        errorMessage.innerHTML = error.message;
        errorMessage.style.opacity = 0;

        targetInputRow.appendChild(errorMessage);

        let fadeInError = anime.timeline({
          targets: errorMessage,
          duration: 400,
          easing: 'easeInOutQuad',
          autoplay: false,
        })
        .add({
          opacity: 1,
        });

        fadeInError.play();

      }

    } else {
      if (response.redirect) {
        let redirectUrl = response.redirect_page;

        if ( 'forward_data_field_data' in response ) {
          let urlQuery = '?' + response.forward_data_field_name + '=' + response.forward_data_field_data;
          redirectUrl += urlQuery;
        }

        window.location.replace(redirectUrl);

      } else {
        let main = document.querySelector('main');
        main.style.minHeight = main.offsetHeight + 'px';

        this.form.innerHTML = '';
        this.form.classList.add('flex-column');

        let messageTitle = document.createElement('h2');
        messageTitle.innerHTML = response.title;
        messageTitle.classList.add('form__confirmation-title', 'fg-color-blue-dark');
        this.form.appendChild(messageTitle);

        let messageBody = document.createElement('p');
        messageBody.innerHTML = response.message;
        messageBody.classList.add('form__confirmation-body', 'fg-color-blue-dark');
        this.form.appendChild(messageBody);

        this._scrollFormIntoView(250);
      }

    }
  }

  _scrollFormIntoView(offset) {
      let scrollTo = this.form;
      let y = scrollTo.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({top: y - offset, behavior: 'smooth'});
  }
}

export default Form;



// WEBPACK FOOTER //
// ./scripts/components/Form.js